import { render } from "./WatchlistCard.vue?vue&type=template&id=27095a3a&scoped=true"
import script from "./WatchlistCard.vue?vue&type=script&lang=js"
export * from "./WatchlistCard.vue?vue&type=script&lang=js"

import "./WatchlistCard.vue?vue&type=style&index=0&id=27095a3a&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dotter/dotter/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27095a3a"]])

export default __exports__